import { render, staticRenderFns } from "./DrawingFile.vue?vue&type=template&id=cb648e9c&scoped=true"
import script from "./DrawingFile.vue?vue&type=script&lang=js"
export * from "./DrawingFile.vue?vue&type=script&lang=js"
import style0 from "./DrawingFile.vue?vue&type=style&index=0&id=cb648e9c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb648e9c",
  null
  
)

export default component.exports